import SvgIcon from '@/components/SvgIcon'

export default {
    install(app) {
        app.component('SvgIcon', SvgIcon)
    }
}